import { combineReducers } from 'redux'
import dnsrecords from './dnsrecords'

const manage = combineReducers({ dnsrecords })

export default manage
